export interface PopupStyles {
  paddingVertical: number;
  paddingHorizontal: number;
  margin: number;
  fullscreen: boolean;
  fieldHeadingFontSize: number;
  borderRadius: number;
}

export const defaultFormPopupStyles: PopupStyles = {
  margin: 40,
  paddingHorizontal: 60,
  paddingVertical: 60,
  fieldHeadingFontSize: 24,
  borderRadius: 20,
  fullscreen: false
};

export const mediumFormPopupStyles: PopupStyles = {
  ...defaultFormPopupStyles,
  paddingHorizontal: 40,
  paddingVertical: 40
};

export const smallFormPopupStyles: PopupStyles = {
  ...defaultFormPopupStyles,
  margin: 0,
  paddingHorizontal: 20,
  paddingVertical: 48,
  fieldHeadingFontSize: 22,
  borderRadius: 0,
  fullscreen: true
};
